import { Component, EventEmitter } from '@angular/core';
import { AlertController, ModalController, NavController, NavParams } from 'ionic-angular';
import { distinctUntilChanged, debounceTime, switchMap } from 'rxjs/operators';
import { forkJoin } from 'rxjs';

import { MenuService } from '../../../providers/menu-service';
import { AlertService } from '../../../providers/alert-service';
import { UsuarioService } from '../../../providers/usuario-service';
import { GestaoPcaService } from '../../../providers/gestao-pca-service';
import { RolAssinantesService } from "../../../providers/rol-assinantes-service";
import { AGORA } from "../../../app/AGORA";
import { Observable } from "rxjs";
import { ModulosController } from '../modulos-controller';
import { RolresponsaveisService } from "../../../providers/rolresponsaveis-service";

@Component({
  selector: 'page-cadastro-assinante',
  templateUrl: 'cadastro-assinante.html',
  providers: [
    AGORA,
    RolAssinantesService
  ]
})
export class CadastroAssinantesPage extends ModulosController {

  buscandoCEPFuncional: boolean = false;

  selectedItem: any;
  selectedCargo: any;
  selectedCargoTemp: any;

  PCAAtiva: any;
  listaAssinantes: any[];
  listaEstados: any = [];
  listaCidades: any = [];
  listaCidadesEnderecoPessoal: any = [];
  listaCidadesEnderecoFuncional: any = [];
  listaTiposTelefone: any = [];
  listaTipoTelefone1: any = [{ "idTipoContato": 1, "dsTipoContato": "Telefone Particular" }, { "idTipoContato": 2, "dsTipoContato": "Telefone Comercial" }];

  listaCargos: any = [];

  cpfInvalido: boolean = false;
  cpfPreenchido: boolean = false;
  cpfCarregado: boolean = true;

  formInvalido: boolean = true;

  typeahead = new EventEmitter<string>();

  isCGE: boolean = false;
  analise: any = null;

  constructor(public AGORA: AGORA,
    public rolAssinantesService: RolAssinantesService,
    public rolResponsaveisService: RolresponsaveisService,
    public usuarioService: UsuarioService,
    public modalCtrl: ModalController,
    public alertCtrl: AlertController,
    public navCtrl: NavController,
    public navParams: NavParams,
    public gestaoPcaService: GestaoPcaService,
    public alertService: AlertService,
    public menuService: MenuService) {
    super(modalCtrl, navParams, alertService, usuarioService, gestaoPcaService);


    this.isCGE = this.usuarioService.isCGE();

    this.analise = this.navParams.get('analise');

    this.PCAAtiva = this.gestaoPcaService.getPCA();
    this.novoAssinante();
    this.carregarListas();
    this.carregarEstados();

    this.typeahead
      .pipe(distinctUntilChanged(), debounceTime(200), switchMap(term => this.buscarCidades(term)))
      // .distinctUntilChanged()
      // .debounceTime(200)
      // .switchMap(term => this.buscarCidades(term))
      .subscribe(items => {
        this.listaCidades = items;
      }, (err) => {
        console.log(err);
        this.listaCidades = [];
      });
    this.setModuloId(16);
  }

  buscarCidades(term: string): Observable<any[]> {
    return this.rolAssinantesService.buscarCidades(term);
  }

  carregarListas() {
    forkJoin([
      this.rolAssinantesService.buscarCargosSAP(),
      this.rolAssinantesService.buscarTiposTelefone()
    ]).subscribe(result => {
      // console.log("CARREGOU LISTAS");
      this.listaCargos = result[0];

      this.listaTiposTelefone = result[1];
      var index = this.listaTiposTelefone.indexOf('Fax');
      this.listaTiposTelefone.splice(index, 1);

      console.log("LISTA TIPOS TELEFONE");
      console.log(JSON.stringify(this.listaTiposTelefone));

      this.selectAssinante(this.navParams.get('assinante'));
      console.log("ASSINANTE");
      console.log(JSON.stringify(this.selectedItem));

    },
      error => {
        console.log("ERRO AO CARREGAR ALGUMA LISTA");
      });
  }

  selectAssinante(item) {
    if (item) {
      // console.log("ACHOU");
      this.selectedItem = item;
      this.atualizaCargo();

    } else {
      // console.log("SETOU NOVO");
      this.novoAssinante();
    }
  }

  atualizaCargo() {
    let itemId = this.selectedItem.idCargoSAP;
    this.selectedCargo = this.listaCargos.find(function (obj) {
      return obj.idCargo === itemId
    });
  }

  novoAssinante() {
    this.selectedItem = {
      idAssinante: "",
      dsNome: "",
      nuCpf: "",
      idPca: "",
      idCargoSAP: "",
      dsCargoSAP: "",
      enderecoModelList: [
        {
          idAssinanteEndereco: "",
          nmLogradouro: "",
          dsComplemento: "",
          dsNumero: "",
          nmBairro: "",
          dsCep: "",
          idCidade: "",
          idTipoEndereco: "",
          idAssinante: "",
          flAtivo: true
        }
      ],
      telefoneModelList: [
        {
          idAssinanteTelefone: "",
          nmTelefone: "",
          tipoContato: "",
          idAssinante: ""
        }
      ],
      emailModelList: [
        {
          idAssinanteEmail: "",
          dsEmail: "",
          idAssinante: ""
        }
      ]
    };
    this.selectedCargo = "";
  }


  listarTiposTelefones() {
    this.rolAssinantesService.buscarTiposTelefone().subscribe(data => {
      this.listaTiposTelefone = data;
      var index = this.listaTiposTelefone.indexOf('Fax');
      this.listaTiposTelefone.splice(index, 1);
    },
      error => {
        console.log("erro: " + error);
      });
  }

  adicionarTelefone() {
    let item: any = {
      idAssinanteTelefone: "",
      nmTelefone: "",
      tipoContato: "",
      idAssinante: ""
    };

    this.selectedItem.telefoneModelList.push(item);
  }

  removerTelefone(tel) {
    this.selectedItem.telefoneModelList.splice(this.selectedItem.telefoneModelList.indexOf(tel), 1);
  }

  compareTelefone(e1: any, e2: any): boolean {
    return e1 && e2 ? e1.idTipoContato === e2.idTipoContato : e1 === e2;
  }

  adicionaEmail() {

    let item: any = {
      idAssinanteEmail: "",
      dsEmail: "",
      idAssinante: ""
    };

    this.selectedItem.emailModelList.push(item);
  }

  removerEmail(email) {
    this.selectedItem.emailModelList.splice(this.selectedItem.emailModelList.indexOf(email), 1);
  }

  validarCPF(cpf) {
    let ehValido = true;

    cpf = cpf.replace(/[^\w\s]/gi, '');

    if (cpf == '') {
      this.cpfInvalido = false;
      return false;
    }

    if (cpf.length != 11) {
      this.cpfInvalido = false;
      return false;
    }

    // Elimina CPFs invalidos conhecidos
    if (cpf == "00000000000" || cpf == "11111111111" || cpf == "22222222222" ||
      cpf == "33333333333" || cpf == "44444444444" || cpf == "55555555555" ||
      cpf == "66666666666" || cpf == "77777777777" || cpf == "88888888888" || cpf == "99999999999") {
      this.cpfInvalido = true;
      return false;
    }

    // Valida 1o digito
    let add = 0;
    for (let i = 0; i < 9; i++)
      add += parseInt(cpf.charAt(i)) * (10 - i);
    let rev = 11 - (add % 11);
    if (rev == 10 || rev == 11)
      rev = 0;
    if (rev != parseInt(cpf.charAt(9))) {
      this.cpfInvalido = true;
      return false;
    }

    // Valida 2o digito
    add = 0;
    for (let i = 0; i < 10; i++) {
      add += parseInt(cpf.charAt(i)) * (11 - i);
    }
    rev = 11 - (add % 11);
    if (rev == 10 || rev == 11)
      rev = 0;
    if (rev != parseInt(cpf.charAt(10))) {
      this.cpfInvalido = true;
      return false;
    }

    return ehValido;
  }

  onCPFAlterado() {
    if (this.validarCPF(this.selectedItem.nuCpf)) {
      this.cpfInvalido = false;
      this.buscarPessoaPorCPF(this.selectedItem.nuCpf);
    } else {
      this.mostrarAlerta("CPF Inválido", "Por favor informe o CPF corretamente.");
      this.selectedItem.nuCpf = "";
      this.cpfPreenchido = false;
    }
  }

  buscarPessoaPorCPF(cpf) {
    cpf = cpf.replace(/[^\w\s]/gi, '');

    this.cpfCarregado = false;
    this.rolAssinantesService.bucarAssinantePorCpf(cpf).subscribe(data => {
      if (data != null && data.nomePessoa != "") {
        this.selectedItem = data;
        this.validaForm();
        this.carregarCidadesDosEnderecosParaEdicao(this.selectedItem);
      }
      this.cpfPreenchido = this.cpfCarregado = true;
    },
      error => {
        console.log("erro: " + error);
        this.cpfPreenchido = this.cpfCarregado = true;
      });
  }

  carregarCidadesDosEnderecosParaEdicao(pessoa) {
    this.rolResponsaveisService.buscarCidadesPorEstado(this.selectedItem.enderecoModelList[0].cidadeModel.estado.idEstado).subscribe(data => {
      this.listaCidadesEnderecoPessoal = data;
      this.selectedItem.enderecoModelList[0].idCidade = pessoa.enderecoModelList[0].idCidade;
    }, error => {
      this.alertService.mostraAlerta("", "Ocorreu um erro ao buscar as cidades para o estado selecionado:" + error);
      console.log("erro: " + error);
    });
  }

  mostrarAlerta(titulo, subtitulo) {
    let alert = this.alertCtrl.create({
      title: titulo,
      subTitle: subtitulo,
      buttons: ['Confirmar']
    });
    alert.present();
  }

  validaForm() {

    let emailOK = true;
    for (let item of this.selectedItem.emailModelList) {
      if (item.dsEmail === '') {
        emailOK = false;
      }
    }

    let telefoneOK = true;
    for (let item of this.selectedItem.telefoneModelList) {
      if (item.nmTelefone === '' || item.tipoContato === '') {
        telefoneOK = false;
      }
    }

    let cargoOK = false;
    for (let item of this.listaCargos) {
      if (item.nomeCargo === this.selectedCargoTemp) {
        cargoOK = true;
        this.selectedCargo = item;
      }
    }

console.log(this.selectedCargo);
    if (emailOK && telefoneOK && cargoOK) {
      this.formInvalido = false;
    }

  }

  salvarAssinante() {

    this.selectedItem.idCargoSAP = this.selectedCargo.idCargo;
    this.selectedItem.dsCargoSAP = this.selectedCargo.nomeCargo;
    this.selectedItem.idPca = this.PCAAtiva.id;

    if (!this.formInvalido) {

      this.selectedItem.emailModelList = this.selectedItem.emailModelList.filter(
        tel => tel.dsEmail != '');
      this.selectedItem.telefoneModelList = this.selectedItem.telefoneModelList.filter(
        tel => tel.nmTelefone != '');

      this.selectedItem.nuCpf = this.formatarCpf(this.selectedItem.nuCpf);

      this.rolAssinantesService.salvarAssinante(this.selectedItem).subscribe(data => {
        this.voltar();
        this.alertService.mostraAlerta("", "Assinante salvo com sucesso!");
      }, error => {
          this.alertService.mostraAlerta("", "Ocorreu um erro ao salvar o assinante: " + error.mensagem);
          // console.log("erro: " + error);
        });
    } else {
      this.alertService.mostraAlerta("Dados incompletos", "Favor preencha os campos em vermelho.");
    }


  }

  voltar() {
    let idSecaoPaginaGestaoPCA = '968';
    if (this.analise == undefined) {
      this.menuService.redirecionarPagina(idSecaoPaginaGestaoPCA);
    } else {
      this.menuService.redirecionarSubPagina(idSecaoPaginaGestaoPCA, this.analise);
    }
  }

  formatarCpf(valor) {
    return valor.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/g, "\$1.\$2.\$3\-\$4");
  }

  cepValido(cep) {
    return cep.toString().replace('-', '').length == 8;
  }

  carregarEstados() {
    this.rolResponsaveisService.buscarEstados().subscribe(data => {
      this.listaEstados = data;
    },
      error => {
        console.log("erro: " + error);
      });
  }

  onCEPAlteradoEnderecoFuncional() {
    if (this.cepValido(this.selectedItem.enderecoModelList[0].dsCep)) {
      this.buscandoCEPFuncional = true;
      this.rolResponsaveisService.buscarEnderecoPorCEP(this.selectedItem.enderecoModelList[0].dsCep).subscribe(data => {
        // console.log(data);
        if (data != undefined && !data.erro) {
          this.selectedItem.enderecoModelList[0].nmLogradouro = data.logradouro;
          this.selectedItem.enderecoModelList[0].nmBairro = data.bairro;

          console.log(this.listaEstados);
          let estadoTemp = this.listaEstados.filter((estado) => data.uf.toUpperCase() == estado.dsSigla.toUpperCase())[0];
          if (estadoTemp) {
            this.rolResponsaveisService.buscarCidadesPorEstado(estadoTemp.idEstado).subscribe(dataCidades => {
              this.listaCidadesEnderecoFuncional = dataCidades;

              let cidadeTemp = this.listaCidadesEnderecoFuncional.filter((cidade) => data.localidade.toUpperCase() == cidade.nmCidade.toUpperCase())[0];
              if (cidadeTemp != null) {
                // this.pessoaAtual.enderecoFuncional.idCidade = cidadeTemp.idCidade;
                this.selectedItem.enderecoModelList[0].cidadeModel = cidadeTemp;
              }
              else {
                this.limparCamposEnderecoFuncional();
              }
              this.buscandoCEPFuncional = false;
            },
              error => {
                console.log("erro: " + error);
                this.limparCamposEnderecoFuncional();
                this.buscandoCEPFuncional = false;
              });
          } else {
            this.buscandoCEPFuncional = false;
          }
        } else {
          this.buscandoCEPFuncional = false;
          this.limparCamposEnderecoFuncional();
        }
      }, (error) => {
        this.buscandoCEPFuncional = false;
        console.log(error);
      });
    }
  }

  limparCamposEnderecoFuncional() {
    this.selectedItem.enderecoModelList[0].nmLogradouro
      = this.selectedItem.enderecoModelList[0].nmBairro
      = this.selectedItem.enderecoModelList[0].cidadeModel = "";
  }

}



// WEBPACK FOOTER //
// ./src/pages/modulos/rol-assinantes/cadastro-assinante.ts